/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const CANCEL_BTN_TEXT = 'Cancel';
export const SAVE_BTN_TEXT = 'Save';
export const POLICIES_ASSOCIATE_SUCCESS = 'Built-in policies successfully added to the role ';
export const POLICIES_ASSOCIATE_ERROR = 'Error on adding built-in policies : ';
export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as const
};
